import { DataTestId } from '@mews-distributor/common';

export const createCheckoutFormFieldDataTestId = (fieldName: string) =>
    `${DataTestId.CheckoutFieldPrefix}-${fieldName}`;
